import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_BLACK_OVERLAY } from '../../redux/actions/types';
import { Dialog } from '@headlessui/react';
import { editPricingBanner } from '../../redux/actions/userActivity';
import { IKImage } from 'imagekitio-react';
const LearnDrawer = ({deviceInfo}) => {
console.log('inside drawrr' , deviceInfo);
const isDarkOverlay = useSelector((store)=> store?.appTheme?.blackOverlay);
const dispatch = useDispatch();
if (!deviceInfo) {
  return null; // Or any placeholder content you prefer
}
function getBrowserlogo(browser){
  if(browser === 'Unknown'){
    return '/img/browser/Default.png'
  }
  return `/img/browser/${browser}.svg`;
}

  return (
    <Dialog open={isDarkOverlay?.showModal == true && isDarkOverlay?.is_closed == false}
    onClose={()=> null}
    // onClose={() =>
    //     // setDiscountModal(prev => ({ ...prev, open: false, data: null }))
    // }
    as="div"
    style={{ zIndex: '9999999999' }}
    className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-20 justify-center flex-col items-center">
    <Dialog.Overlay className="fixed inset-0 bg-black opacity-50 z-10" />
    <Dialog.Title />
    <Dialog.Description />
    {/* <div className="absolute z-[99999999] inset-0 bg-black bg-opacity-50" ></div> */}
    <div className={`fixed bottom-0 z-[999999999] flex flex-col w-full h-[230px] show-animation justify-start items-center    rounded-t-2xl bg-white py-6 px-3 text-white`}>
        <div className='w-full text-[18px] text-black font-semibold text-center'>Continue Learning On...</div>
        <div className='w-full flex flex-row justify-between items-center mt-6'>
          <div className='flex justify-center items-center '>
              <div className='border-2 border-[#D3D3D3] flex items-center justify-center w-[52px] h-[52px] rounded-xl mr-4'> 
                  <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/image_11.png?updatedAt=1685175860985" width={32} height={32} alt="learntube logo" />
              </div>
              <div className='flex flex-col justify-center items-start'>
                <div className='text-black text-[16px] font-semibold'>LearnTube App</div>
                <div className='text-[11px] text-[#1CA571] font-medium flex gap-2'>Get<img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Ai%20notes/Group%2020631.svg?updatedAt=1716999520358`}
                  className="h-[12px] w-[12px]"
                  transformation={[{
                      "height": "60",
                      "width": "60",
                  }]}
                />+100 On Your First Use</div>
              </div>
          </div>
          <button className='bg-[#1CA571] text-[16px] font-semibold  text-white w-[106px] py-2 rounded-3xl' onClick={() => window.open("https://learntube.page.link/web_landing", "_blank", 'noopener,noreferrer')}>Open</button>
        </div>

        <div className='w-full flex flex-row justify-between items-center mt-4'>
          <div className='flex justify-center items-center '>
              <div className='border-2 border-[#D3D3D3] flex items-center justify-center w-[52px] h-[52px] rounded-xl mr-4'> 
                  <img src={getBrowserlogo(deviceInfo?.browser_name)} width={32} height={32} alt="browser logo" />
              </div>
              <div className='text-black text-[16px] font-semibold'>{deviceInfo?.browser_name === "Unknown" ? "Browser" : deviceInfo?.browser_name}</div>
          </div>
          <button className='bg-[#E3E8EC] text-[16px] font-semibold w-[106px]  text-black py-2 rounded-3xl' onClick={(e)=> {dispatch(editPricingBanner(false)) ;  dispatch({type: SET_BLACK_OVERLAY , payload : ({...isDarkOverlay , is_closed : true , showModal : false , is_expired : true , expire_time : (new Date().getTime() + 24*60*60*1000)})});} }>Continue</button>
        </div>
    </div>
    </Dialog>
  )
}

export default LearnDrawer
